$('[data-tab]').first().addClass('active');
$('[data-tab-content]').first().addClass('opened');
$(document).ready(function () {  
  $('[data-tab]').first().addClass('active');
  $('[data-tab-content]').first().addClass('opened');

  $('body').on('click', '[data-tab]', function (event) {
    event.preventDefault(); 
    var $tab = $(this); 
    var tabContentSelector = '[data-tab-content="' + $tab.attr('data-tab') + '"]';
    var $content = $(tabContentSelector); 
    if (!$tab.hasClass('active') && !$content.hasClass('opened')) {
      $tab.addClass('active').siblings().removeClass('active');
      $content.siblings().hide().removeClass('opened');
      $content.fadeIn().addClass('opened');
    }
  });

  $(".sub-menu button").click(function () {
    var $submenu = $(this).parent(".sub-menu").children("ul");
  
    // Hide all other open submenus
    $(".sub-menu ul").not($submenu).slideUp("100");
    $(".sub-menu button").not($(this)).attr("aria-expanded", "false");
  
    // Toggle the visibility of the clicked submenu
    $submenu.slideToggle("100", function () {
      // Toggle the aria-expanded attribute after the animation is complete
      var expanded = $submenu.is(":visible") ? "true" : "false";
      $(this)
        .prev(".header-sidebar__linklist-button")
        .attr("aria-expanded", expanded);
    });
  });
  
  $("#header--search").click(function () {
    $("body").addClass("search_main");
  });

  $("body").on('click', '.header__search-link', function () {
    $("body").addClass("search_main");
  });
  
  $("#close_button").click(function () {
    $("body").removeClass("search_main");
  });

  $(document.querySelector('header-search').shadowRoot.querySelector('[part="overlay"]')).click(function () {
    $("body").removeClass("search_main");
  });

  $('header-search dialog-close-button button').click(function () {
    $("body").removeClass("search_main");
  });
    
  $(".Collapsible__Button").click(function () {
    // Get the corresponding .Collapsible__Inner for the clicked button
    var $inner = $(this).next(".Collapsible__Inner");

    // Check if the clicked collapsible is already active
    var isActive = $inner.hasClass("active");

    // Close all collapsibles except the clicked one
    $(".Collapsible__Inner").not($inner).removeClass("active").slideUp();

    // Remove collapsible_wrapper class from all Product__Tabs except the one in the clicked collapsible
    $(".Product__Tabs.collapsible_wrapper")
      .not($inner.find(".Product__Tabs"))
      .removeClass("collapsible_wrapper");

    // Toggle the active class on the clicked collapsible with slide toggle animation
    $inner.slideToggle().toggleClass("active");

    // Toggle the collapsible_wrapper class on the Product__Tabs within the clicked collapsible
    $inner.find(".Product__Tabs").toggleClass("collapsible_wrapper");

    // Toggle the 'collap_icon' class on all buttons
    $(".Collapsible__Button").not($(this)).removeClass("collap_icon");
    $(this).toggleClass("collap_icon");

    // Toggle the 'border-removed' class on all buttons
    $(".Collapsible__Button").not($(this)).removeClass("border-removed");
    $(this).toggleClass("border-removed");
  });

  $(".size-inner-chart").click(function () {
    $(".size-inner-chart").removeClass("active");
    $(this).addClass("active");
    var size_button = $(this).attr("data-tab");
    $(".size-chart-main").each(function () {
      var size_chart = $(this).attr("data-tab-content");
      if (size_button == size_chart) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  $(".look-item_title").click(function () {
    $("body").addClass("add-overlay");
  });
  
  $(".Drawer__Close").click(function () {
    $("body").removeClass("add-overlay");
  });
    
  // Event handler for opening the popup
  // $(".open_popup").click(function (e) {
  //   e.preventDefault(); // Prevent default action
  //   var index = $(this).data("index"); // Get the index from the data attribute
  //   $(".popup-data").removeClass("active").hide(); // Hide all popups
  //   $("#popup_" + index)
  //     .addClass("active")
  //     .show(); // Show the specific popup
  //   $("body").addClass("add-overlay"); // Add overlay class to body
  // });

  // // Event handler for closing the popup
  // $(".Drawer__Close").click(function () {
  //   $(this).closest(".popup-data").removeClass("active").hide(); // Hide the closest popup to the clicked close button
  //   $("body").removeClass("add-overlay"); // Remove overlay class from body
  // });

  // // Event handler for clicking outside the popup
  // $(document).mouseup(function (e) {
  //   var popup = $(".popup-data.active");
  //   if (!popup.is(e.target) && popup.has(e.target).length === 0) {
  //     // if the target of the click isn't the popup nor a descendant of the popup
  //     popup.removeClass("active").hide(); // Hide the popup
  //     $("body").removeClass("add-overlay"); // Remove overlay class from body
  //   }
  // });

  function lookbook_close(){
    $("#lookbook__section-popup .Drawer__Title").empty();
    $("#lookbook__section-popup .Drawer__img").empty();
    $('#lookbook__section-popup .LookBookProduct .ProductList').empty();
  }

  $(".lookbook__section .open_popup").click(function (e) {
    e.preventDefault();
    let image = $(this).parents('.look-item').find('.look-item-image').attr('src');
    let title = $(this).data('title');
    let products = $(this).data('products')? $(this).data('products').split(',') : [];

    $("#lookbook__section-popup .Drawer__Title").text(title);
    $("#lookbook__section-popup .Drawer__img").html('<img src="'+ image +'">');

    if(products.length > 0){
      const container = $('#lookbook__section-popup .LookBookProduct .ProductList');
      $(products).each(function(i, item){
        fetch(`/products/${item}?view=lookbook-product-card`).then(res => res.text()).then(text => {
          const parser = new DOMParser();
          const html = parser.parseFromString(text, 'text/html');
          var block = `<div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/2--desk">${html.body.innerHTML}</div>`
          $('#lookbook__section-popup .LookBookProduct .ProductList').append(block);
        })
      });
    }

    setTimeout(function(){
      $("#lookbook__section-popup").addClass("active").show();
      $("body").addClass("add-overlay");
      setTimeout(function(){
        const sliders = document.querySelectorAll("#lookbook__section-popup .product-card-slider");
          if(sliders){
              sliders.forEach((slider) => {
              const bars = slider.querySelectorAll(".progress-bar");
              const productCard = slider.closest('.product-card');
              const swiper = new Swiper(slider, {
                  loop: true,
                  slidesPerView: 1,
                  effect: 'fade',
                  fadeEffect: {
                      crossFade: true
                  },
                  navigation: {
                  nextEl: slider.querySelector(".swiper-button-next"),
                  prevEl: slider.querySelector(".swiper-button-prev"),
                  },
                  breakpoints: {
                      768: {
                          allowTouchMove: false,
                      }
                  },
                  on: {
                  slideChange: function () {
                      updateBars(this);
                  },
                  init: function () {
                      updateBars(this);
                  }
                  }
              });

              function updateBars(swiper) {
                  let index = swiper.realIndex;

                  bars.forEach((bar, i) => {
                      bar.classList.remove("active");
                  });

                  if (bars[index]) {
                      bars[index].classList.add("active");
                  }
              }

              if (productCard) {
                  productCard.addEventListener('mouseenter', function () {
                      swiper.slideToLoop(1); // 👉 go to second slide
                  });
                  productCard.addEventListener('mouseleave', function () {
                      swiper.slideToLoop(0); // 👉 back to first slide
                  });
              }
            });
          }
      },1000);
    },500);
  });

  // Event handler for closing the popup
  $(".lookbook__section .Drawer__Close").click(function () {
    $(this).closest("#lookbook__section-popup").removeClass("active").hide();
    $("body").removeClass("add-overlay");
    setTimeout(lookbook_close, 500);
  });

  // Event handler for clicking outside the popup
  $(document).click(function (e) {
    var popup = $(".lookbook__section #lookbook__section-popup");
    var popup_btn = $(".lookbook__section .open_popup");
    if (!popup.is(e.target) && popup.has(e.target).length === 0 && !popup_btn.is(e.target) && popup_btn.has(e.target).length === 0) {
      popup.removeClass("active").hide();
      $("body").removeClass("add-overlay");
      setTimeout(lookbook_close, 500);
    }
  });

  $('body').on('click','.wk-product-form .ProductForm__AddToCart', async function(e) {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
    var _this8 = $(this).closest('form');  
    var _button = $(this);
    _button.html('Added To Cart');

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const formData = new FormData(_this8[0]);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${Shopify.routes.root}variants/${$(_this8).find('[name="id"]').val()}`);
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });
    const responseJson = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
        cart: cartContent,
        onSuccessDo: formData.get("on_success")
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        onSuccessDo: formData.get("on_success"),
        cart: cartContent
      }
    }));
  });
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = window.themeVariables.settings.moneyFormat;

    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
     function addBtnText(disable, text, btnClass) {
      if (!btnClass) {
        return;
      }
      if (disable) {
        btnClass.prop('disabled', true);
        if (text) {
          btnClass.html(text);
        }
      } else {
        btnClass.prop('disabled', false);
        btnClass.html('Add To Cart');
      }
    }
  function varaintSelect(form) {
      var handle = form.find('.wk-product-form__options').data('product');
      var fieldsets = form.find('.ProductForm__Option').toArray();
      var addButton = form.find('.ProductForm__AddToCart');
      var options = [];
      
      $.each(fieldsets, function (i, v){ 
        var value = $(v).find("input[type='radio']:checked").val();
        options.push(value);
      });
      
      console.log(options);
      $.getJSON('/products/'+handle+'.js', function(product) {
        var getVariantData = product.variants;

        var currentVariant;
        $.each(getVariantData, function (i, variant){
          var lll = 0;
          $.each(variant.options, function (index, option){ 
            if(options[index] !== option){
              lll = 1;
            }
          });
          if(lll == 0){
            currentVariant = variant;
          }
        });
   
        addBtnText(true, '', addButton)
  
        if (!currentVariant) {
          addBtnText(true, '', addButton);
          if (!addButton) {
            return;
          }
          addButton.html('Unavailable');
        } else {
  
          if (!currentVariant) {
            return;
          }
          form.find('[name="id"]').val(currentVariant.id);
          form.parent().find('.wk-product-image').css('background-image', 'url('+currentVariant.featured_image.src.replace('.jpg', '_1000x.jpg')+')');
          form.parent().find('.wk-product-price--current').html((Shopify.formatMoney(currentVariant.price)).replace('.00', ''));
          addBtnText(!currentVariant.available, 'Sold Out', addButton);
        }
      })
     
    }
   $('body').on('change', '.wk-product-form__options input', function() {
    var form = $(this).closest('form');
    varaintSelect(form); 
  });

   $(".tab_click").click(function(e){
      e.preventDefault();
      if ($(this).closest('.faq_col').hasClass('active')){
        $(".faq_col").removeClass("active");
        $(".faq_col .faq_content").slideUp(300);			
      } else {
        $(".faq_col").removeClass("active");
        $(this).closest('.faq_col').addClass('active'); 
        $(".faq_col .faq_content").slideUp(300);		
        $(".faq_col.active .faq_content").slideToggle(300);
      }
    });
    
});